import React from 'react';
import { Slide, Fade  } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import Carousel from './Carousel.Slider';

const Home = () => {

  const spanStyle = {
    padding: '20px',
    // background: '#efefef',
    // color: '#000000',
    width: '50%',
    fontSize: '36px',

    // color: '#e96b56',
    color: 'rgb(172 11 188)',
    marginBottom: '30px',
    fontSize: '48px',
    fontWeight: 700,
    textAlign: 'center',
    // opacity: 1,
    // backgroundColor: 'rgba(0, 0, 0, 0.9)',
    // position: 'relative',
    // background: 'rgba(0, 0, 0, 0.3)',
    opacity: 1.0,

  }
  
  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    height: '610px',
    zIndex:0,
    borderRadius: '5px!important',
    // width:'70%'
    opacity: 0.7,
    // backgroundColor: 'rgba(0, 0, 0, 0.1)',
    // background: 'rgba(0, 0, 0, 0.5)',

  }


  const slideImages = [
    {
      //url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
      url:'111.jpg',
      caption: 'Welcome to Haryana Library Association'
    },
    {
      //url: 'https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80',
      url:'222.jpg',
      caption: 'Welcome to Haryana Library Association'
    },
    {
      //url: 'https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
      url:'333.jpg',
      caption: 'Welcome to Haryana Library Association'
    },
  ];

  let slides = [
    // "https://i.pinimg.com/originals/51/82/ac/5182ac536727d576c78a9320ac62de30.jpg",
    // "https://getwallpapers.com/wallpaper/full/5/c/0/606489.jpg",
    // "https://wallpaperaccess.com/full/809523.jpg",
    // "https://getwallpapers.com/wallpaper/full/5/c/0/606489.jpg",
    '111.jpg',
    '222.jpg',
    '333.jpg'


  ];
  

  return (

<>
{/* <div className="w-[80%]  m-auto py-11 mt-10">
      <Carousel slides={slides} />     
    </div> */}

    {/* // <div name='home' className='w-full h-screen'>
    // <div name='home' className='w-full mx-auto px-8  flex flex-col justify-center h-screen'> */}
    <div className="mt-24 overflow-hidden"> 
        <Slide >
         {slideImages.map((slideImage, index)=> (
            <div key={index}>
              <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
                <span style={spanStyle}>{slideImage.caption}</span>
              </div>
            </div>
          ))} 
        </Slide>
 
        </div>
       
      {/* Container */}
      {/* <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        
        <h1 className='text-4xl sm:text-7xl font-bold text-[#e547b8]'>
          SAI KUMAR
        </h1>
        <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>
          I'm a Full Stack Developer.
        </h2>
        <p className='text-[#8892b0] py-4 max-w-[700px]'>
          I’m a full-stack developer specializing in building (and occasionally
          designing) exceptional digital experiences. Currently, I’m focused on
          building responsive full-stack web applications.
        </p>
        <div>
          <button className='text-blue group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
            View Work
            <span className='group-hover:rotate-90 duration-300'>
              <HiArrowNarrowRight className='ml-3 ' />
            </span>
          </button>
        </div>
      </div> */}
    {/* </div> */}
    </>
  );
};

export default Home;
